import { Product } from '../model';
import dayjs from 'dayjs';

export const ProductCard = (props: Product) => {
  // new_productフラグ
  let newProductFrag = '';
  let spNewProductFrag = '';
  if (props.new_product) {
    newProductFrag = `<span id='new-product-fragment'></span>`;
    spNewProductFrag = `<span id='sp-new-product-fragment'></span>`;
  }

  // updated_atのフォーマット
  let formatDate: string = '';
  formatDate = dayjs(props.updated_at).format('YYYY/MM/DD');

  // favorite
  let favorite = '';
  if (props.favorite) {
    favorite = `
      <img
        class='like'
        src='../assets/img/icon_iine_add.png'
        alt='${props.product_name}'
        style='display: none'
      />
      <img
        class='like like-delete'
        src='../assets/img/icon_iine_delete.png'
        alt='${props.product_name}'
      />
    `;
  } else {
    favorite = `
      <img
        class='like'
        src='../assets/img/icon_iine_add.png'
        alt='${props.product_name}'
      />
      <img
        class='like like-delete'
        src='../assets/img/icon_iine_delete.png'
        alt='${props.product_name}'
        style='display: none'
      />
    `;
  }
  if(!props.product_name){
    props.product_name = ''; 
  }
  
  if (!props.img_url) {
    props.img_url =
      'https://giftnet-storage.s3.ap-northeast-1.amazonaws.com/assets/no-image.png';
  }

  return `
  <div
    class="product-result__card card col-lg-3 col-5 mb-3 mb-sm-5 mx-1 mx-sm-2 card-shadow  p-0"
  >
    ${newProductFrag}
    <div>
      <a href="${props.url}">
        <div class="product-image-container">
          ${spNewProductFrag}
          <img
            aria-label="Placeholder: Image cap"
            class="product-result__img bd-placeholder-img card-img-top"
            focusable="false"
            preserveAspectRatio="xMidYMid slice"
            role="img"
            src="${props.img_url}"
            width="320"
            height="320"
          />
        </div>
      </a>
    </div>
    <div class="card-body">
      <span class="product-result__term d-block">${props.name_tag}</span>
      <a href="${props.url}">
        <h5 class="card-title product-result__title">${props.product_name}</h5>
      </a>
      <span class="card-text product-result__company d-block">
        ${props.registered_name}
      </span>
      <div class="card-bottom">
        <a
          class="card-link d-block product-result__search d-flex"
          href="${props.url}"
        >
          <span class="d-block trn" data-trn-key='productUrl'>商品ページへ</span>
        </a>
        
        <div class='product-result__likes card-link ${
          props.favorite && 'favorite-active'
        }' data-isLike='${props.favorite}' data-shop_id='${
    props.shop_id
  }' data-product_id='${props.product_id}'>
          ${favorite}
          <span class='trn' data-trn-key='productLike'>いいね</span>
        </div>
      </div>
      <span class="product-result__date d-block"
        >
        <span class='trn' data-trn-key='productDate'>最終更新日：</span>
         ${formatDate}</span
      >
    </div>
  </div>
  `;
};
